import { useEffect, useRef, useState } from 'react';

const parse = (value) => {
  const m = String(value).match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
  if (!m) return null;
  const num = parseFloat(m[2].replace(',', '.'));
  const decimals = (m[2].split(/[.,]/)[1] || '').length;
  return { prefix: m[1], num, decimals, suffix: m[3], sep: m[2].includes(',') ? ',' : '.' };
};

const reduceMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export const CountUp = ({ value, duration = 1600, className, style, format, ...rest }) => {
  const p = parse(value);
  const ref = useRef(null);
  const [current, setCurrent] = useState(p && !reduceMotion() ? 0 : p?.num);

  useEffect(() => {
    if (!p || reduceMotion() || !ref.current) return undefined;
    let raf;
    const obs = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      obs.disconnect();
      const start = performance.now();
      const tick = (now) => {
        const k = Math.min(1, (now - start) / duration);
        setCurrent(p.num * (1 - Math.pow(1 - k, 3)));
        if (k < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    obs.observe(ref.current);
    return () => { obs.disconnect(); cancelAnimationFrame(raf); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (!p) return <span className={className} style={style} {...rest}>{value}</span>;
  const shown = format ? format(current) : current.toFixed(p.decimals).replace('.', p.sep);
  return (
    <span ref={ref} className={className} style={{ fontVariantNumeric: 'tabular-nums', ...style }} aria-label={String(value)} {...rest}>
      {format ? shown : <>{p.prefix}{shown}{p.suffix}</>}
    </span>
  );
};
